<script>
    import { fly } from "svelte/transition";
    import { Avatar, Cell } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Avatar
            src="/assets/boy.png"
        />
    </div>
    <h4 class="example-title">占位头像</h4>
    <div class="example-body">
        <Avatar />
    </div>
    <h4 class="example-title">自定义尺寸</h4>
    <div class="example-body space">
        <Avatar
        src="/assets/boy.png"
            --size="22px"
        />
        <Avatar
        src="/assets/boy.png"
        />
        <Avatar
        src="/assets/boy.png"
            --size="66px"
        />
    </div>
    <h4 class="example-title">配合列表使用</h4>
    <div class="example-body">
        <Cell title="Novalee Spicer">
            <Avatar slot="icon" src="/assets/girl.png" />
            Deserunt dolor ea eaque eos
        </Cell>
    </div>
</div>

<style lang="less">
    @import "./example.less";
    .space {
        display: flex;
        :global(.sui-avatar) {
            margin: 0 10px 10px 0;
        }
    }
</style>
